
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactForm from '../../components/base/ContactForm';
import TestimonialsSlider from '../../components/base/TestimonialsSlider';

export default function ResidentialPaintingPage() {
  useEffect(() => {
    document.title = 'Residential Painting Durbanville | Professional House Painters Western Cape';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional residential painting services in Durbanville, Western Cape. Expert house painters for interior and exterior home painting projects. Quality workmanship and materials.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'residential painting Durbanville, house painters Western Cape, home painting, residential painters, house painting services');
    }
  }, []);

  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/e3ee711081ff3cf1be26a350f2cf6e07.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-bold mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
            Residential <span style={{ color: '#e9f638' }}>PAINTING</span>
          </h1>
          <p className="text-2xl md:text-3xl mb-8 font-light">
            Transform your home with professional residential painting services
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/contact" 
              className="text-black px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#e9f638' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#d4e532'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#e9f638'}
            >
              Get Free Quote
            </a>
            <a 
              href="#services" 
              className="border-2 border-white hover:bg-white hover:text-black text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Our Services
            </a>
          </div>
        </div>
      </section>

      {/* Residential Painting Services */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Residential Painting Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our expert residential painters in Durbanville provide comprehensive home painting solutions, from single rooms to complete home makeovers, with attention to detail and quality craftsmanship.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-home-4-line text-2xl text-black"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Complete Home Painting</h3>
              <p className="text-gray-600">
                Full interior and exterior home painting services including all rooms, hallways, and outdoor surfaces.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-door-line text-2xl text-black"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Room-by-Room Painting</h3>
              <p className="text-gray-600">
                Individual room painting including bedrooms, living rooms, kitchens, bathrooms, and specialty spaces.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-palette-line text-2xl text-black"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Color Consultation</h3>
              <p className="text-gray-600">
                Professional color consultation to help you choose the perfect colors that complement your home's style.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-brush-line text-2xl text-black"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Surface Preparation</h3>
              <p className="text-gray-600">
                Thorough surface preparation including cleaning, sanding, filling, and priming for optimal paint adhesion.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-magic-line text-2xl text-black"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Decorative Finishes</h3>
              <p className="text-gray-600">
                Specialty painting techniques including feature walls, textured finishes, and decorative paint effects.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-shield-check-line text-2xl text-black"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Quality Assurance</h3>
              <p className="text-gray-600">
                Comprehensive quality checks and professional touch-ups to ensure perfect results throughout your home.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Residential Painting */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6">Why Invest in Professional Residential Painting?</h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1" style={{ backgroundColor: '#e9f638' }}>
                    <i className="ri-check-line text-black font-bold"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Increased Home Value</h3>
                    <p className="text-gray-600">Professional residential painting can increase your home's value by 5-10% and significantly improve its market appeal.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1" style={{ backgroundColor: '#e9f638' }}>
                    <i className="ri-check-line text-black font-bold"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Enhanced Living Experience</h3>
                    <p className="text-gray-600">Fresh paint creates a clean, welcoming environment that improves your daily living experience and comfort.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1" style={{ backgroundColor: '#e9f638' }}>
                    <i className="ri-check-line text-black font-bold"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Protection and Durability</h3>
                    <p className="text-gray-600">Quality residential painting protects your home's surfaces from wear, moisture, and environmental damage.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1" style={{ backgroundColor: '#e9f638' }}>
                    <i className="ri-check-line text-black font-bold"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Time and Stress Savings</h3>
                    <p className="text-gray-600">Professional painters complete projects efficiently while you focus on enjoying your newly transformed home.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Beautiful%20Durbanville%20family%20home%20with%20fresh%20professional%20paint%20job%2C%20happy%20family%20in%20front%20of%20house%2C%20modern%20residential%20architecture%2C%20well-maintained%20garden%2C%20South%20African%20suburban%20setting%2C%20excellent%20curb%20appeal&width=600&height=400&seq=residential-benefits&orientation=landscape"
                alt="Professional residential painting results"
                className="rounded-lg shadow-lg w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Home Areas We Paint */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6">Home Areas We Paint</h2>
            <p className="text-xl text-gray-600">
              Comprehensive painting services for every area of your home
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-sofa-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Living Areas</h3>
              <p className="text-gray-600">Living rooms, family rooms, and entertainment spaces with quality finishes.</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-hotel-bed-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Bedrooms</h3>
              <p className="text-gray-600">Master bedrooms, children's rooms, and guest bedrooms with appropriate finishes.</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-restaurant-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Kitchen & Dining</h3>
              <p className="text-gray-600">Kitchens and dining areas with moisture-resistant and easy-clean paints.</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-drop-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Bathrooms</h3>
              <p className="text-gray-600">Bathrooms and wet areas with specialized moisture-resistant coatings.</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-home-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Exterior Walls</h3>
              <p className="text-gray-600">Exterior walls, trim, and architectural features with weather-resistant paints.</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-door-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Doors & Trim</h3>
              <p className="text-gray-600">Interior and exterior doors, window frames, and decorative trim work.</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-building-2-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Ceilings</h3>
              <p className="text-gray-600">Interior ceilings with appropriate finishes and texture matching.</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-stairs-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Staircases</h3>
              <p className="text-gray-600">Staircases, railings, and multi-level areas with durable finishes.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6">Our Other Painting Services</h2>
            <p className="text-xl text-gray-600">
              Explore our complete range of professional painting services in Durbanville
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <a href="/interior-painting" className="group bg-white p-6 rounded-lg transition-all duration-300 cursor-pointer" onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9f638'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}>
              <div className="w-12 h-12 group-hover:bg-black rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-home-4-line text-xl text-black group-hover:text-yellow-400"></i>
              </div>
              <h3 className="text-xl font-bold mb-2 group-hover:text-black">Interior Painting</h3>
              <p className="text-gray-600 group-hover:text-black">Professional interior painting for homes and offices.</p>
            </a>

            <a href="/exterior-painting" className="group bg-white p-6 rounded-lg transition-all duration-300 cursor-pointer" onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9f638'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}>
              <div className="w-12 h-12 group-hover:bg-black rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-home-line text-xl text-black group-hover:text-yellow-400"></i>
              </div>
              <h3 className="text-xl font-bold mb-2 group-hover:text-black">Exterior Painting</h3>
              <p className="text-gray-600 group-hover:text-black">Professional exterior painting services for homes and buildings.</p>
            </a>

            <a href="/roof-painting" className="group bg-white p-6 rounded-lg transition-all duration-300 cursor-pointer" onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9f638'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}>
              <div className="w-12 h-12 group-hover:bg-black rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-building-2-line text-xl text-black group-hover:text-yellow-400"></i>
              </div>
              <h3 className="text-xl font-bold mb-2 group-hover:text-black">Roof Painting</h3>
              <p className="text-gray-600 group-hover:text-black">Specialized roof painting and waterproofing services.</p>
            </a>

            <a href="/commercial-painting" className="group bg-white p-6 rounded-lg transition-all duration-300 cursor-pointer" onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9f638'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}>
              <div className="w-12 h-12 group-hover:bg-black rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#e9f638' }}>
                <i className="ri-building-line text-xl text-black group-hover:text-yellow-400"></i>
              </div>
              <h3 className="text-xl font-bold mb-2 group-hover:text-black">Commercial Painting</h3>
              <p className="text-gray-600 group-hover:text-black">Large-scale commercial and industrial painting projects.</p>
            </a>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Get Your Residential Painting Quote</h2>
          <p className="text-xl text-gray-300 mb-12">
            Ready to transform your home? Get a free quote from Durbanville's best residential painters.
          </p>
          <ContactForm />
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <TestimonialsSlider />
        </div>
      </section>

      {/* Elfsight AI Chatbot */}
      <script src="https://elfsightcdn.com/platform.js" async></script>
      <div className="elfsight-app-bd0c8f1c-533d-413e-bee7-63e0ccb9fdbf" data-elfsight-app-lazy></div>

      {/* ProveSource Code */}
      <script dangerouslySetInnerHTML={{
        __html: `!function(o,i){window.provesrc&&window.console&&console.error&&console.error("ProveSource is included twice in this page."),provesrc=window.provesrc={dq:[],display:function(){this.dq.push(arguments)}},o._provesrcAsyncInit=function(){provesrc.init({apiKey:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50SWQiOiI2NmQzYzc2NjQ3MWQwZDE2NTI2N2VkZDAiLCJpYXQiOjE3MjUxNTUxNzR9.F74G52UprvsGoyXgXsaIMG-PS-c2G7yr84Ut5rrQ4cg",v:"0.0.4"})};var r=i.createElement("script");r.type="text/javascript",r.async=!0,r["ch"+"ar"+"set"]="UTF-8",r.src="https://cdn.provesrc.com/provesrc.js";var e=i.getElementsByTagName("script")[0];e.parentNode.insertBefore(r,e)}(window,document);`
      }} />

      <Footer />
    </>
  );
}
